import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'reactstrap';

import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import moment from 'moment';

import {DABBL_PUBLISHER_ID} from '../../../config';
import Button from "../../../shared/components/Button";
import DropdownButton from "../../../shared/components/DropdownButton";

class AccountTransferHistory extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for AccountTransferHistory in componentDidMount
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after AccountTransferHistory in componentWillUnmount
  }

  renderEventCell(item){
    if(item.fromAccountId === DABBL_PUBLISHER_ID){
      if(item.kind === 'invoice'){
        return (<strong>Funds Added (Invoice)</strong>)
      } else if(item.kind === 'card'){
        return (<strong>Funds Added (Self Serve)</strong>)
      } else if(item.kind === 'adjoy'){
        return (<strong>Funds Added (Dabbl Pays)</strong>)
      }
    } else if(item.fromAccountId === this.props.accountId){
      return (<strong>Experience Launched</strong>)
    } else if(item.toAccountId === this.props.accountId){
      return (<strong>Funds Added (Experience)</strong>)
    } else {
      return (<strong>Other</strong>)
    }
  }

  renderDescriptionCell(item){
    console.log('ITEM ',item);
    // if(item.io && item.io.length > 0 && item.fromAccountId === DABBL_PUBLISHER_ID){
    //   return (<span>{item.io}</span>)
    // } else
      if(item.io){
      return (<span>{item.io}</span>)
    } else if(item.fromAccountId === this.props.accountId){
      return (<span>Experience: {item.toName}</span>)
    } else if(item.toAccountId === this.props.accountId){
      return (<span>Experience: {item.fromName}</span>)
    } 

    return (<span></span>)
  }
  renderDocuments(documents){
      if (!documents || documents.length === 0){
          return ''
      }
      console.log(documents)
      return (<span>{documents.map((d)=><span><a href={d.url}>{d.fileName}</a><br/></span>)}</span>)
    }

  renderAmountCell(item){
    if(item.fromAccountId === this.props.accountId){
      return (<span>(<MoneyDisplay>{item.amount}</MoneyDisplay>)</span>)
    } else {
      return (<span><MoneyDisplay>{item.amount}</MoneyDisplay></span>)
    }
  }

  getAmount(item){
    if(item.fromAccountId === this.props.accountId){
      return -1 * item.amount;
    } else {
      return 1 * item.amount;
    }
  }

   download(filename, url) {
    var element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  onDownloadClick(e, item){
    e.preventDefault()
    this.download(item.fileName, item.url);
  }

  render(){
    const { balance, transfers } = this.props;
    const documents = transfers.filter((t)=>(t.documents && t.documents.length > 0)).map((t) => t.documents.map((d) => ({lastModifiedDate: t.lastModifiedDate, ...d}))).reduce((total, documents) => total.concat(documents), [])

    return (
      <div className='AccountTransferHistory'>
        {/*  <Row><h4>IO History</h4></Row>*/}
        {/*<Row>*/}
        {/*  <Col xs='12'>*/}
        {/*    <SearchableDataTable*/}
        {/*        items={documents}*/}
        {/*        hideSearch*/}
        {/*        emptyText='No IO Documents'*/}
        {/*        columns={[*/}
        {/*          {*/}
        {/*            name:'date',*/}
        {/*              display:'Date',*/}
        {/*            width:15,*/}
        {/*            sortFunc:(a,b) => a.lastModifiedDate - b.lastModifiedDate,*/}
        {/*            renderCell:(item) => <span>{moment(item.lastModifiedDate).format('MMM D, YYYY')}</span>*/}
        {/*          },*/}
        {/*          {*/}
        {/*            name:'name',*/}
        {/*              display:'IO File name',*/}
        {/*            width:30,*/}
        {/*            renderCell:(item) => <strong>{item.fileName}</strong>*/}
        {/*          },*/}
        {/*          {*/}
        {/*            name:'download',*/}
        {/*            width:30,*/}
        {/*            renderCell:(item) => <Button className='ml-2' onClick={(e) => this.onDownloadClick(e, item)}>Download</Button>*/}
        {/*          }*/}
        {/*        ]}*/}
        {/*    />*/}
        {/*  </Col>*/}
        {/*</Row>*/}
        {/*  <Row><h4>Funding Timeline</h4></Row>*/}
        <Row>
          <Col xs='12'>
            <SearchableDataTable 
              items={transfers}
              hideSearch
              emptyText='No transfer history'
              columns={[
                {
                  name:'event',
                  width:30,
                  renderCell:(item) => this.renderEventCell(item)
                },
                {
                  name:'description',
                  width:20,
                  renderCell:(item) => this.renderDescriptionCell(item)
                },
                  {
                      name:'io_documents',
                      display:'IO Documents',
                      width:35,
                      renderCell:(item) => this.renderDocuments(item.documents)
                  },
                {
                  name:'date',
                  width:15,
                  sortFunc:(a,b) => a.lastModifiedDate - b.lastModifiedDate,
                  renderCell:(item) => <span>{moment(item.lastModifiedDate).format('MMM D, YYYY')}</span>
                },
                {
                  name:'amount',
                  width:15,
                  sortFunc:(a,b) => this.getAmount(a) - this.getAmount(b),
                  renderCell:(item) =>  this.renderAmountCell(item)
                },{
                  width:10,
                  renderCell:(item) => (
                      <div className='pull-right'>
                          {item.kind === 'invoice' &&
                        <Button
                            size='sm'
                            linkHref={`${this.props.match.url}/${item.id}`}
                            textColor='#666666'
                            borderColor='#cccccc'
                            backgroundColor='#fff'
                        >
                          Edit
                        </Button>
                          }
                      </div>
                  )
                }
              ]}
            />
            <div className='pull-right'>
              <br />
              <h5>Current Balance: <strong><MoneyDisplay>{balance}</MoneyDisplay></strong>&nbsp;&nbsp;&nbsp;</h5>
            </div>
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </div>
    );
  }
}

AccountTransferHistory.propTypes = {
  //TODO: Fill in prop types for AccountTransferHistory
};

AccountTransferHistory.defaultProps = {
  //TODO: Fill in defaultProps for AccountTransferHistory
};

export default AccountTransferHistory;



// WEBPACK FOOTER //
// ./src/routes/AccountTransferHistory/components/AccountTransferHistory.js